import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useFilterSearchBarStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      flexFlow: 'wrap',
      marginTop: 35,
      width: '100%',
      [theme.breakpoints.down(960)]: {
        marginTop: 25,
        padding: 0
      }
    },

    action: {
      cursor: 'pointer'
    },

    input: {
      flex: 1,
      paddingLeft: 18,
      background: '#FAFAFA',
      borderRadius: 4,
      boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)'
    },

    button: {
      display: 'flex',
      marginLeft: 10,
      width: 174,
      height: 50,
      lineHeight: 0,
      textTransform: 'none'
    },

    privateRequest: {
      display: 'flex',
      marginTop: 12,
      paddingBottom: 5,
      width: '100%',
      minHeight: 35,
      overflowX: 'auto',
      overflowY: 'hidden',

      ['&::-webkit-scrollbar']: {
        height: '5px',
        borderRadius: '4px'
      },
      ['&::-webkit-scrollbar-track']: {
        backgroundColor: '#c9c9c9',
        borderRadius: '4px'
      },
      ['&::-webkit-scrollbar-thumb']: {
        backgroundColor: '#b5b3b3',
        borderRadius: '4px'
      }
    },

    hidden: {
      marginTop: 12,
      paddingBottom: 5,
      width: '100%',
      minHeight: 35
    },

    privateRequestButton: {
      padding: 0,
      marginRight: 16,
      minWidth: 'auto',
      fontWeight: 400,
      fontSize: '14px',
      color: '#757575',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',

      [theme.breakpoints.down(960)]: {
        fontSize: '12px'
      },
      ['&:last-child']: {
        marginRight: 0
      }
    }
  })
)
